/** RGBA 8비트 래스터. 색은 premultiplied 가 아닌 직선 값이고, data 길이는 width·height·4 다. */
export interface Raster {
  readonly width: number;
  readonly height: number;
  readonly data: Uint8ClampedArray;
}

/** 픽셀 하나의 바이트 수(R·G·B·A). */
export const RGBA_CHANNELS = 4;

/** 투명 검정으로 채운 래스터를 만든다. 크기가 양의 정수가 아니면 RangeError 다. */
export function createRaster(width: number, height: number): Raster {
  assertRasterSize(width, height);
  return { width, height, data: new Uint8ClampedArray(width * height * RGBA_CHANNELS) };
}

/** 기존 RGBA 버퍼를 복사하지 않고 래스터로 감싼다. 크기가 양의 정수가 아니거나 버퍼 길이가 맞지 않으면 RangeError 다. */
export function rasterFrom(width: number, height: number, data: Uint8ClampedArray): Raster {
  assertRasterSize(width, height);
  if (data.length !== width * height * RGBA_CHANNELS) {
    throw new RangeError(
      `버퍼 길이 ${data.length} 가 ${width}×${height}×${RGBA_CHANNELS} 와 다르다`,
    );
  }
  return { width, height, data };
}

function assertRasterSize(width: number, height: number): void {
  if (!Number.isInteger(width) || !Number.isInteger(height) || width <= 0 || height <= 0) {
    throw new RangeError(`래스터 크기 ${width}×${height} 가 양의 정수가 아니다`);
  }
}
